import React from "react"
import SharpImage from "../utils/sharpImage"
import Box from "@material-ui/core/Box";
import FeatureCardStyles from "./featureCard.styles";
import { useTheme } from "@material-ui/core/styles";

interface Props {
    image?: string;
    color: string;
    children: any;
    imageSize?: string;
    images: Array<any>;
}

export const FeatureCard = ({ image, color, children, imageSize, images }: Props) => {
    const classes = FeatureCardStyles();
    const theme = useTheme();

    if (imageSize !== "sml" && imageSize !== "md" && imageSize !== "lg")
        imageSize = "md"; //Default to md

    let asset = null;
    if (image && images)
        asset = images.filter(x => x.assetId === image)[0];

    const getBackground = () => {
        if (color === "darkest")
            return theme.palette.primary.darkest;
        else if (color === "dark")
            return theme.palette.primary.dark;
        else if (color === "main")
            return theme.palette.primary.main;
        else if (color === "light")
            return theme.palette.primary.light;
        else if (color === "lightest")
            return theme.palette.primary.lightest;
        else
            return theme.palette.background.paper
    }

    return (
        <div className={classes.featureCardContainer} style={{ backgroundColor: getBackground(), color: theme.palette.getContrastText(getBackground()) }}>
            <Box className={`${classes.featureCardContentContainer} ${imageSize === "sml" ? classes.featureCardContentContainerImgSml : ""}  ${imageSize === "md" ? classes.featureCardContentContainerImgMd : ""}  ${imageSize === "lg" ? classes.featureCardContentContainerImgLg : ""}`}>
                {children}
            </Box>
            <div className={`${classes.featureCardImgContainer} ${imageSize === "sml" ? classes.featureCardImgContainerSml : ""}  ${imageSize === "md" ? classes.featureCardImgContainerMd : ""}  ${imageSize === "lg" ? classes.featureCardImgContainerLg : ""}`}>
                {asset && asset.localFile ?
                    <div style={{ top: "50%", transform: "translateY(-50%)", height: "100%", position: "relative" }}><div className={classes.featureCardImg}><SharpImage file={asset.localFile} title={asset.fileName} altText={asset.fileName} /></div></div>
                    : <></>}
            </div>
        </div>
    );
}

FeatureCard.NAME = "FeatureCard";
export default FeatureCard
